import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private hubConnection: signalR.HubConnection;
  private listenerAdded: boolean = false;
  private notificationsCountSubject = new BehaviorSubject<number>(0);
  notificationsCount$ = this.notificationsCountSubject.asObservable();

  private getNotificationEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Notification/GetNotification';
  private getNotificationCountEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Notification/GetNotificationCount';
  private readNotificationEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Notification/ReadNotification';
  private deleteNotificationEndpoint = environment.ECO_WASTE_SERVICE_URL + '/Notification/DeleteNotification';

  constructor(private messageService: MessageService, private http: HttpClient) {
  }

  public startConnection(token: string): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(`${environment.ECO_WASTE_URL}/notificationHub`, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => token
    })
    .withAutomaticReconnect() // Enable automatic reconnection
    .build();

    // Handle reconnection attempts
    this.hubConnection.onreconnecting(error => {
      console.log(`Reconnecting... Error: ${error}`);
    });

    // Handle successful reconnection
    this.hubConnection.onreconnected(connectionId => {
      console.log('Reconnected successfully. Connection ID:', connectionId);
    });

    // Handle permanent disconnection
    this.hubConnection.onclose(error => {
      console.log(`Connection closed. Error: ${error}`);
    });

    this.hubConnection.start()
      .then(() => {
        console.log('SignalR connection started');
        // Save token to localStorage to persist the connection
        localStorage.setItem('signalRToken', token);
      })
      .catch(err => console.error('Error while starting SignalR connection: ' + err));

    this.loadNotificationCount();
  }

  public addNotificationListener(): void {
    if (this.hubConnection && !this.listenerAdded) {
      this.hubConnection.on('ReceiveNotification', (message) => {
        console.log('Notification received: ' + message);
        this.messageService.add({ severity: 'info', summary: 'Notification', detail: message });
        const currentCount = this.notificationsCountSubject.value;
        this.notificationsCountSubject.next(currentCount + 1);
      });
    }

    this.listenerAdded = true; // Prevent adding multiple listeners
  }

  // Method to disconnect
  public stopConnection() {
    if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      this.hubConnection.stop()
        .then(() => {
          console.log('SignalR connection stopped');
          localStorage.removeItem('signalRToken'); // Clear the token when stopping the connection
        })
        .catch(err => console.error('Error while stopping SignalR connection: ' + err));
    }
  }

  loadNotificationCount() {
    this.getNotificationCount().subscribe({
        next: response => {
            console.log('Noti', response);
            this.notificationsCountSubject.next(response);
            // this.loadingNoti = false;
        },
        error: error => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error}` });
        }
    })
}

  getNotification(): Observable<any> {
    const url = `${this.getNotificationEndpoint}`;
    return this.http.get<any>(url);
  }

  getNotificationCount(): Observable<any> {
    const url = `${this.getNotificationCountEndpoint}`;
    return this.http.get<any>(url);
  }

  readNotification(id: any): Observable<any> {
    console.log("Service", id)
    const url = `${this.readNotificationEndpoint}?id=${id}`;
    return this.http.put<any>(url, null);
  }

  deleteNotification(id: any): Observable<any> {
    console.log("Service", id)
    const url = `${this.deleteNotificationEndpoint}?id=${id}`;
    return this.http.put<any>(url, null);
  }
}
